<template>
    <Popover v-model:open="isOpen">
        <PopoverAnchor>
            <PopoverTrigger :class="['multi-select focus-visible:outline-none', classes]">
                <span class="truncate">{{ selectedLabel ?? label }}</span>
            </PopoverTrigger>
        </PopoverAnchor>
        <PopoverContent
            :align-flip="true"
            :disable-popover-portal="!teleportPopover"
            :prioritize-position="true"
            align="start"
            class="popover-content p-0"
        >
            <Command :highlight-on-hover="false" selection-behavior="manual">
                <CommandList>
                    <CommandEmpty class="p-2 text-start text-base">{{ trans('general.selection.options.empty') }}</CommandEmpty>
                    <CommandGroup class="flex flex-col">
                        <CommandItem
                            v-for="option in options"
                            :key="option.value"
                            :value="option.value"
                            as="div"
                            class="flex cursor-pointer items-center gap-2 rounded-lg p-2 text-base! hover:bg-primary! hover:text-white data-[highlighted]:bg-transparent! data-[highlighted]:text-inherit! data-[highlighted]:hover:bg-primary! data-[highlighted]:hover:text-white!"
                            @select="select(option.value)"
                        >
                            <span class="flex h-4 w-4 shrink-0 items-center justify-center">
                                <Icon v-if="option.value === modelValue" class="h-3.5 w-3.5" icon="cil-check-circle" />
                            </span>
                            <span class="min-w-0 flex-1">
                                <slot :option="option" name="label">
                                    <span class="truncate">{{ option.label }}</span>
                                </slot>
                            </span>
                        </CommandItem>
                    </CommandGroup>
                </CommandList>
            </Command>
        </PopoverContent>
    </Popover>
</template>
<script setup>
import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/Components/ui/command';
import { Popover, PopoverAnchor, PopoverContent, PopoverTrigger } from '@/Components/ui/popover';
import { computed, ref } from 'vue';
import { trans } from '@/mixins/i18n.js';
import Icon from '@/Components/Icon.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    label: String,
    name: String,
    options: {
        type: Array,
        default: () => [],
    },
    modelValue: {
        type: [String, Number, null],
        default: null,
    },
    classes: [String, Array],
    // Render the popover in a body-level portal so an ancestor containing block
    // (e.g. the filter bar's `container-type`) doesn't throw off its position.
    teleportPopover: {
        type: Boolean,
        default: false,
    },
});

const isOpen = ref(false);
const selectedLabel = computed(() => props.options.find((option) => option.value === props.modelValue)?.label ?? null);

const select = (value) => {
    emit('update:modelValue', value);
    isOpen.value = false;
};
</script>
